/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { default as React, useState } from "react";
import { IContactTag } from "../../../generated/Api";
import { IContact } from "../../../types/Contact";
import Campaigns from "./Campaigns";
import CustomFields from "./CustomFields";
import Emails from "./Emails";
import HeaderContactDetails from "./HeaderContactDetails";
import Notes from "./Notes";
import Orders from "./Orders";
import Tags from "./Tags";
import Webforms from "./Webforms";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;
  background-color: white;
  padding-bottom: 20px;
`;

const TopBorder = styled.span`
  position: absolute;
  top: 0;
  background: transparent linear-gradient(180deg, #edbc37 0%, #d09800 100%) 0%
    0% no-repeat padding-box;
  border-radius: 2px;
  height: 90px;
  width: 100%;
  z-index: 1;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 30px;
  width: 100%;
  margin: 0px 40px;
  /* z-index: 2; */
  position: relative;
`;

const TableContainer = styled.div`
  display: flex;
  height: fit-content;
  justify-content: center;
  font-size: 15px;
  padding: 20px;
  border: 1px solid #ededed;
  border-radius: 0px 0px 5px 5px;
  background-color: white;
`;

export enum ContactTab {
  EMAILS = "EMAILS",
  TAGS = "TAGS",
  WEBFORMS = "WEBFORMS",
  CAMPAIGNS = "CAMPAIGNS",
  ORDERS = "ORDERS",
  NOTES = "NOTES",
  CUSTOM_FIELDS = "CUSTOM_FIELDS",
}

interface Props {
  individualTags: IContactTag[];
  contact: IContact;
  searchContacts?: (signal?: AbortSignal) => Promise<{
    contacts: IContact[];
    total: number;
  }>;
}

export default function ContactsDetails(props: Props): JSX.Element {
  const { contact, individualTags, searchContacts } = props;
  const [selected, setSelected] = useState(ContactTab.EMAILS);

  function handleSelected(vle: ContactTab) {
    setSelected(vle);
  }

  function returnBody(screen: ContactTab) {
    switch (screen) {
      case ContactTab.EMAILS:
        return <Emails contact={contact} />;
      case ContactTab.TAGS:
        return (
          <Tags
            contact={contact}
            individualTags={individualTags}
            searchContacts={searchContacts}
          />
        );
      case ContactTab.WEBFORMS:
        return <Webforms contact={contact} />;
      case ContactTab.CAMPAIGNS:
        return <Campaigns contact={contact} />;
      case ContactTab.ORDERS:
        return <Orders />;
      case ContactTab.NOTES:
        return <Notes contact={contact} />;
      case ContactTab.CUSTOM_FIELDS:
        return <CustomFields contact={contact as any} />;
      default:
    }
    return (
      <Tags
        contact={contact}
        individualTags={individualTags}
        searchContacts={searchContacts}
      />
    );
  }

  return (
    <Container>
      {/* It will put in the future */}
      {/* <TopBorder /> */}

      <Body>
        <HeaderContactDetails
          selected={selected}
          handleSelected={handleSelected}
        />
        <TableContainer>{returnBody(selected)}</TableContainer>
      </Body>
    </Container>
  );
}
